import React, { useEffect } from 'react';
import styled from 'styled-components';
import Library from 'src/components/Library';
import { usePanelContext } from 'src/context/PanelContext';
import { PANEL_WIDTHS_PX } from 'src/constants/panelSizes';
import { Panel } from './Panel';

const LibraryPanelWrapper = styled(Panel)`
  width: 40rem;
`;

interface LibraryPanelProps {
  isOpen: boolean;
}

export const LibraryPanel: React.FC<LibraryPanelProps> = ({ isOpen }) => {
  const { setPanelWidth } = usePanelContext();

  // Report the fixed library width on mount
  useEffect(() => {
    setPanelWidth('lib', PANEL_WIDTHS_PX.LIBRARY);
  }, [setPanelWidth]);

  return (
    <LibraryPanelWrapper isOpen={isOpen} side="left" offset={0}>
      <Library />
    </LibraryPanelWrapper>
  );
};
